import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { getNavigationByPath } from '../../../config/navigation';
import { useAppLayout } from '../../../hooks/useAppLayout';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';
import styles from './AppLayout.module.css';

const AppLayout = ({ children, breadcrumbItems, showSidebar = true }) => {
  const location = useLocation();
  const {
    isMRV,
    handleCompanyToggle,
    onTrocarLoja,
    temMultiplasLojas,
    nomeLojaAtiva,
    isSidebarCollapsed,
    toggleSidebar,
  } = useAppLayout();

  // Auto-detects breadcrumb if not provided
  const currentNav = getNavigationByPath(location.pathname);
  const finalBreadcrumbItems = breadcrumbItems || currentNav?.breadcrumb || [];

  return (
    <>
      <Header isMRV={isMRV} onCompanyToggle={handleCompanyToggle} />
      <Breadcrumb
        items={finalBreadcrumbItems}
        onTrocarLoja={onTrocarLoja}
        temMultiplasLojas={temMultiplasLojas}
        nomeLojaAtiva={nomeLojaAtiva}
      />

      {showSidebar ? (
        <div className={styles.pageContainer}>
          <Sidebar isCollapsed={isSidebarCollapsed} onToggleCollapse={toggleSidebar} />
          <main className={styles.mainContent}>{children}</main>
        </div>
      ) : (
        <div className="container">{children}</div>
      )}
    </>
  );
};

AppLayout.propTypes = {
  children: PropTypes.node.isRequired,
  breadcrumbItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      link: PropTypes.string,
    })
  ),
  showSidebar: PropTypes.bool,
};

export default AppLayout;
